module.exports = __webpack_public_path__ + "02_glasses_red.82240720.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/02_glasses_red.png
// module id = EvT4
// module chunks = 0